import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import api from "../api/api";
import Header from "./Header";

export default function CustomerMaster() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isEdit = !!id;
  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("lastVisited");
    window.location.href = "/";
  };

  const [editData, setEditData] = useState({
     customerType: '',
     mobile: '',
     altMobile: '',
     name: '',
     address: '',
     area: '',
     paymentCycle: '',
     pinCode: '',
     email: '',
     route: '',
     active: '',
     stateCode: '',
     gstNo: '',
   });

   const [addresses, setAddresses] = useState([{ short: "", address: "", area: "", route: "" }]);
   const [showModal, setShowModal] = useState(false);

   const [loading, setLoading] = useState(false);
   const [fetchLoading, setFetchLoading] = useState(false);
   const [errors, setErrors] = useState({});
   const [areas, setAreas] = useState([]);
   const [areaLoading, setAreaLoading] = useState(true);

   const [customerTypes, setCustomerTypes] = useState([]);
   const [activeOptions, setActiveOptions] = useState([]);
   const [paymentCycles, setPaymentCycles] = useState([]);
   const [paymentCycleDetails, setPaymentCycleDetails] = useState([]);
   const [dropdownLoading, setDropdownLoading] = useState(true);
   const [paymentCycleDetailLoading, setPaymentCycleDetailLoading] = useState(false);

   const [searchTerm, setSearchTerm] = useState(editData.area || "");
   const [showAreaList, setShowAreaList] = useState(false);
   const areaRef = useRef(null);
   const listRefArea = useRef(null);

   const [customerTypeSearch, setCustomerTypeSearch] = useState(editData.customerType || "");
   const [showCustomerTypeList, setShowCustomerTypeList] = useState(false);
   const customerTypeRef = useRef(null);
   const listRefCustomerType = useRef(null);

   const [activeSearch, setActiveSearch] = useState(editData.active || "");
   const [showActiveList, setShowActiveList] = useState(false);
   const activeRef = useRef(null);
   const listRefActive = useRef(null);

   const [paymentCycleSearch, setPaymentCycleSearch] = useState(editData.paymentCycle || "");
   const [showPaymentCycleList, setShowPaymentCycleList] = useState(false);
   const paymentCycleRef = useRef(null);
   const listRefPaymentCycle = useRef(null);

   const [paymentCycleDetailSearch, setPaymentCycleDetailSearch] = useState("");
   const [showPaymentCycleDetailList, setShowPaymentCycleDetailList] = useState(false);
   const paymentCycleDetailRef = useRef(null);
   const listRefPaymentCycleDetail = useRef(null);
   const [selectedPaymentCycleDetail, setSelectedPaymentCycleDetail] = useState(null);

   const [activeIndexCustomerType, setActiveIndexCustomerType] = useState(-1);
   const [activeIndexArea, setActiveIndexArea] = useState(-1);
   const [activeIndexPaymentCycle, setActiveIndexPaymentCycle] = useState(-1);
   const [activeIndexPaymentCycleDetail, setActiveIndexPaymentCycleDetail] = useState(-1);
   const [activeIndexActive, setActiveIndexActive] = useState(-1);
   const [isCodAvail, setIsCodAvail] = useState(0);

  useEffect(() => {
    setSearchTerm(editData.area || "");
  }, [editData.area]);

  useEffect(() => {
  const fetchAreas = async () => {
    try {
      const response =
        (await api.GetAreaList?.()) ||
        (await api.get("GetAreaList", {}));

      const list =
        response?.data?.GetAreaListjs?.Table ||
        response?.GetAreaListjs?.Table ||
        [];

      // ✅ normalize keys
      const formatted = list.map(a => ({
        Area: a.city,
        Division: a.Division
      }));

      setAreas(formatted);
    } catch (err) {
      console.error("Area load error", err);
    } finally {
      setAreaLoading(false);
    }
  };

  fetchAreas();
}, []);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (areaRef.current && !areaRef.current.contains(e.target)) {
        setShowAreaList(false);
        setActiveIndexArea(-1);
      }
      if (customerTypeRef.current && !customerTypeRef.current.contains(e.target)) {
        setShowCustomerTypeList(false);
        setActiveIndexCustomerType(-1);
      }
      if (activeRef.current && !activeRef.current.contains(e.target)) {
        setShowActiveList(false);
        setActiveIndexActive(-1);
      }
      if (paymentCycleRef.current && !paymentCycleRef.current.contains(e.target)) {
        setShowPaymentCycleList(false);
        setActiveIndexPaymentCycle(-1);
      }
      if (paymentCycleDetailRef.current && !paymentCycleDetailRef.current.contains(e.target)) {
        setShowPaymentCycleDetailList(false);
        setActiveIndexPaymentCycleDetail(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        setDropdownLoading(true);
        const response = await api.GetGenFdGenvaluesAPI("admin", "1");
        console.log("Main API Response:", response);
        const data = response.GetGenFdGenvaluesAPIjs || response.data || response.GetGenFdGenvaluesAPI || response;
        setCustomerTypes(data.Table || []);
        console.log("Customer Types:", data.Table || []);
        //setAreas(data.Table1 || []);
        console.log("Areas:", data.Table1 || []);
        setActiveOptions(data.Table2 || []);
        console.log("Active Options:", data.Table2 || []);
        setPaymentCycles(data.Table4 || []);
        console.log("Payment Cycles:", data.Table4 || []);
      } catch (error) {
        console.error("❌ Error fetching dropdown data:", error);
      } finally {
        setDropdownLoading(false);
      }
    };
    fetchDropdownData();
  }, []);

  // Auto scroll for customer type dropdown
  useEffect(() => {
    if (listRefCustomerType.current && activeIndexCustomerType >= 0) {
      const item = listRefCustomerType.current.children[activeIndexCustomerType];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexCustomerType]);

  // Auto scroll for area dropdown
  useEffect(() => {
    if (listRefArea.current && activeIndexArea >= 0) {
      const item = listRefArea.current.children[activeIndexArea];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexArea]);

  // Auto scroll for payment cycle dropdown
  useEffect(() => {
    if (listRefPaymentCycle.current && activeIndexPaymentCycle >= 0) {
      const item = listRefPaymentCycle.current.children[activeIndexPaymentCycle];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexPaymentCycle]);

  // Auto scroll for payment cycle detail dropdown
  useEffect(() => {
    if (listRefPaymentCycleDetail.current && activeIndexPaymentCycleDetail >= 0) {
      const item = listRefPaymentCycleDetail.current.children[activeIndexPaymentCycleDetail];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexPaymentCycleDetail]);

  // Auto scroll for active dropdown
  useEffect(() => {
    if (listRefActive.current && activeIndexActive >= 0) {
      const item = listRefActive.current.children[activeIndexActive];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexActive]);

  useEffect(() => {
  if (!isEdit) return;

  const prefill = location.state?.customer;

  // 1️⃣ If we have navigation data, show it immediately
  if (prefill) {
    setEditData({
      customerType: prefill.Customermode || '',
      mobile: prefill.VCode || '',
      altMobile: prefill.Phone || '',
      name: prefill.Vname || '',
      address: prefill.Address1 || '',
      area: prefill.City || '',
      paymentCycle: prefill.TransMode || '',
      pinCode: prefill.Pincode || '',
      email: prefill.Mail || '',
      route: prefill.Route || '',
      active: prefill.Active ? 'Active' : 'Inactive',
      stateCode: prefill.StateCode || '',
      gstNo: prefill.Gst || '',
      division: prefill.Division || '',
    });

    setSearchTerm(prefill.City || "");
    setCustomerTypeSearch(prefill.Customermode || "");
    setActiveSearch(prefill.Active ? 'Active' : 'Inactive');
    setPaymentCycleSearch(prefill.TransMode || "");
  }

  // 2️⃣ ALWAYS fetch full data from API to guarantee correctness
  const fetchCustomerData = async () => {
    try {
      setFetchLoading(true);
      const response = await api.EditFdCustomerlist(id);
      const data = response?.EditFdCustomerlistjs?.Table || [];

      if (data.length > 0) {
        const customer = data[0];

        setEditData({
          customerType: customer.Customermode || '',
          mobile: customer.Vcode || '',
          altMobile: customer.Phone || '',
          name: customer.Vname || '',
          address: customer.Address1 || '',
          area: customer.City || '',
          paymentCycle: customer.TransMode || '',
          pinCode: customer.Pincode || '',
          email: customer.Mail || '',
          route: customer.Division || '',
          active: customer.Active ? 'Active' : 'Inactive',
          stateCode: customer.StateCode || '',
          gstNo: customer.Gst || '',
          division: customer.Division || '',
          IsCodAvail: customer.IsCodAvail || 0
        });

        setSearchTerm(customer.City || "");
        setCustomerTypeSearch(customer.Customermode || "");
        setActiveSearch(customer.Active ? 'Active' : 'Inactive');
        setPaymentCycleSearch(customer.TransMode || "");
        setIsCodAvail(customer.IsCodAvail ? 1 : 0);
        // Fetch payment cycle details for the TransMode
        if (customer.TransMode) {
          const fetchDetails = async () => {
            try {
              const response = await api.GetPaymentCycleAPI(customer.TransMode);
              const data = response.GetPaymentCycleAPIjs || response.data || response.GetPaymentCycleAPI || response;
              setPaymentCycleDetails(data.Table || []);
            } catch (error) {
              console.error("Error fetching payment cycle details:", error);
            }
          };
          fetchDetails();
        }
        // Set selected payment cycle detail from Table2
        const table2 = response?.EditFdCustomerlistjs?.Table2 || [];
        if (table2.length > 0) {
          setPaymentCycleDetailSearch(table2[0].PaymentCycle1);
        }
        // Set additional addresses from Table3
        const table3 = response?.EditFdCustomerlistjs?.Table3 || [];
        setAddresses(table3.map(addr => ({
          short: addr.ShortName || "",
          address: addr.Address1 || "",
          area: addr.Area || "",
          route: addr.Route || "",
        })));
      }
    } catch (error) {
      console.error("❌ Error fetching customer data:", error);
      alert("Failed to load customer data.");
    } finally {
      setFetchLoading(false);
    }
  };

  fetchCustomerData();
}, [isEdit, id]);

 useEffect(() => {
  if (!editData.paymentCycle) return;

  const loadPaymentCycleDetails = async () => {
    try {
      setPaymentCycleDetailLoading(true);

      const response = await api.GetPaymentCycleAPI(editData.paymentCycle);

      const data =
        response?.GetPaymentCycleAPIjs ||
        response?.data ||
        response?.GetPaymentCycleAPI ||
        response;

      const details = data?.Table || [];

      setPaymentCycleDetails(details);

      // ⭐ Auto-select existing detail if present (safe optional)
      if (details.length > 0 && !selectedPaymentCycleDetail) {
        const saved = details.find(
          d => d.PaymentCycle === paymentCycleDetailSearch
        );
        if (saved) {
          setSelectedPaymentCycleDetail(saved);
          setPaymentCycleDetailSearch(saved.PaymentCycle);
        }
      }

    } catch (error) {
      console.error("❌ Error loading payment cycle details:", error);
      setPaymentCycleDetails([]);
    } finally {
      setPaymentCycleDetailLoading(false);
    }
  };

  loadPaymentCycleDetails();
}, [editData.paymentCycle]);

const handleKeyDownCustomerType = (e) => {
  const options = filteredCustomerTypes;
  if (!showCustomerTypeList && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
    setShowCustomerTypeList(true);
    setActiveIndexCustomerType(0);
    return;
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndexCustomerType(i => i < options.length - 1 ? i + 1 : 0);
      break;
    case "ArrowUp":
      e.preventDefault();
      setActiveIndexCustomerType(i => i > 0 ? i - 1 : options.length - 1);
      break;
    case "Enter":
      if (showCustomerTypeList && activeIndexCustomerType >= 0) {
        e.preventDefault();
        const selected = options[activeIndexCustomerType];
        if (selected) {
          setEditData({ ...editData, customerType: selected.Type });
          setCustomerTypeSearch(selected.Type);
          setShowCustomerTypeList(false);
          setActiveIndexCustomerType(-1);
        }
      }
      break;
    case "Escape":
      setShowCustomerTypeList(false);
      setActiveIndexCustomerType(-1);
      break;
    default:
      break;
  }
};

const handleKeyDownArea = (e) => {
  const options = filteredAreas;

  if (!showAreaList && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
    setShowAreaList(true);
    setActiveIndexArea(0);
    return;
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndexArea(i => i < options.length - 1 ? i + 1 : 0);
      break;

    case "ArrowUp":
      e.preventDefault();
      setActiveIndexArea(i => i > 0 ? i - 1 : options.length - 1);
      break;

    case "Enter":
      if (showAreaList && activeIndexArea >= 0) {
        e.preventDefault();
        const selected = options[activeIndexArea];

        setEditData(prev => ({
          ...prev,
          area: selected.Area,
          route: selected.Division   // ✅ AUTO ROUTE
        }));

        setSearchTerm(selected.Area);
        setShowAreaList(false);
        setActiveIndexArea(-1);
      }
      break;

    case "Escape":
      setShowAreaList(false);
      setActiveIndexArea(-1);
      break;
  }
};

const handleKeyDownPaymentCycle = (e) => {
  const options = filteredPaymentCycles;
  if (!showPaymentCycleList && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
    setShowPaymentCycleList(true);
    setActiveIndexPaymentCycle(0);
    return;
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndexPaymentCycle(i => i < options.length - 1 ? i + 1 : 0);
      break;
    case "ArrowUp":
      e.preventDefault();
      setActiveIndexPaymentCycle(i => i > 0 ? i - 1 : options.length - 1);
      break;
    case "Enter":
      if (showPaymentCycleList && activeIndexPaymentCycle >= 0) {
        e.preventDefault();
        const selected = options[activeIndexPaymentCycle];
        if (selected) {
          const value = selected.PaymentCycle;
          setEditData({ ...editData, paymentCycle: value });
          setPaymentCycleSearch(value);
          setShowPaymentCycleList(false);
          setActiveIndexPaymentCycle(-1);
          if (value) {
            // Trigger secondary API
            const fetchDetails = async () => {
              try {
                setPaymentCycleDetailLoading(true);
                const response = await api.GetPaymentCycleAPI(value);
                console.log("Secondary API Response for PaymentCycle:", value, response);
                const data = response.GetPaymentCycleAPIjs || response.data || response.GetPaymentCycleAPI || response;
                setPaymentCycleDetails(data.Table || []);
                console.log("Payment Cycle Details:", data.Table || []);
              } catch (error) {
                console.error("❌ Error fetching payment cycle details:", error);
                setPaymentCycleDetails([]);
              } finally {
                setPaymentCycleDetailLoading(false);
              }
            };
            fetchDetails();
          } else {
            setPaymentCycleDetails([]);
          }
        }
      }
      break;
    case "Escape":
      setShowPaymentCycleList(false);
      setActiveIndexPaymentCycle(-1);
      break;
    default:
      break;
  }
};

const handleKeyDownPaymentCycleDetail = (e) => {
  const options = filteredPaymentCycleDetails;
  if (!showPaymentCycleDetailList && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
    setShowPaymentCycleDetailList(true);
    setActiveIndexPaymentCycleDetail(0);
    return;
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndexPaymentCycleDetail(i => i < options.length - 1 ? i + 1 : 0);
      break;
    case "ArrowUp":
      e.preventDefault();
      setActiveIndexPaymentCycleDetail(i => i > 0 ? i - 1 : options.length - 1);
      break;
    case "Enter":
      if (showPaymentCycleDetailList && activeIndexPaymentCycleDetail >= 0) {
        e.preventDefault();
        const selected = options[activeIndexPaymentCycleDetail];
        if (selected) {
          setSelectedPaymentCycleDetail(selected);
          setPaymentCycleDetailSearch(selected.PaymentCycle);
          setShowPaymentCycleDetailList(false);
          setActiveIndexPaymentCycleDetail(-1);
        }
      }
      break;
    case "Escape":
      setShowPaymentCycleDetailList(false);
      setActiveIndexPaymentCycleDetail(-1);
      break;
    default:
      break;
  }
};

const handleKeyDownActive = (e) => {
  const options = filteredActives;
  if (!showActiveList && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
    setShowActiveList(true);
    setActiveIndexActive(0);
    return;
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();
      setActiveIndexActive(i => i < options.length - 1 ? i + 1 : 0);
      break;
    case "ArrowUp":
      e.preventDefault();
      setActiveIndexActive(i => i > 0 ? i - 1 : options.length - 1);
      break;
    case "Enter":
      if (showActiveList && activeIndexActive >= 0) {
        e.preventDefault();
        const selected = options[activeIndexActive];
        if (selected) {
          setEditData({ ...editData, active: selected.Active });
          setActiveSearch(selected.Active);
          setShowActiveList(false);
          setActiveIndexActive(-1);
        }
      }
      break;
    case "Escape":
      setShowActiveList(false);
      setActiveIndexActive(-1);
      break;
    default:
      break;
  }
};

const handleChange = async (e) => {
     const { name, value } = e.target;
     if (name === "area") {
  const selected = areas.find((a) => a.Area === value);

  setEditData(prev => ({
    ...prev,
    area: value,
    route: selected?.Division || ""   // ✅ MAIN FIX
  }));

  setSearchTerm(value);

     } else if (name === "paymentCycle") {
       setEditData({ ...editData, [name]: value });
       if (value) {
         try {
           setPaymentCycleDetailLoading(true);
           const response = await api.GetPaymentCycleAPI(value);
           console.log("Secondary API Response for PaymentCycle:", value, response);
           const data = response.GetPaymentCycleAPIjs || response.data || response.GetPaymentCycleAPI || response;
           setPaymentCycleDetails(data.Table || []);
           console.log("Payment Cycle Details:", data.Table || []);
         } catch (error) {
           console.error("❌ Error fetching payment cycle details:", error);
           setPaymentCycleDetails([]);
         } finally {
           setPaymentCycleDetailLoading(false);
         }
       } else {
         setPaymentCycleDetails([]);
       }
     } else {
       setEditData({ ...editData, [name]: value });
     }
   };

  // const handleSelectArea = (area) => {
  //   const selected = areas.find((a) => a.Area === area);
  //   setEditData({
  //     ...editData,
  //     area: area,
  //     division: selected ? selected.R1Name : "",
  //   });
  //   setSearchTerm(area);
  //   setShowAreaList(false);
  // };

  const filteredAreas = areas.filter((a) =>
    a.Area && a.Area.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredCustomerTypes = customerTypes.filter((type) =>
    type.Type && type.Type.toLowerCase().includes(customerTypeSearch.toLowerCase())
  );

  const filteredActives = activeOptions.filter((active) =>
    active.Active && active.Active.toLowerCase().includes(activeSearch.toLowerCase())
  );

  const filteredPaymentCycles = paymentCycles.filter((cycle) =>
    cycle.PaymentCycle && cycle.PaymentCycle.toLowerCase().includes(paymentCycleSearch.toLowerCase())
  );

  const filteredPaymentCycleDetails = paymentCycleDetails.filter((detail) =>
    detail.PaymentCycle && detail.PaymentCycle.toLowerCase().includes(paymentCycleDetailSearch.toLowerCase())
  );

  const addRow = () => {
    setAddresses([...addresses, { short: "", address: "", area: "", route: "" }]);
  };

  const deleteRow = (index) => {
    setAddresses(addresses.filter((_, i) => i !== index));
  };

  const validateForm = () => {
    const newErrors = {};

    // Mobile: 10 digits
    if (!editData.mobile || !/^\d{10}$/.test(editData.mobile)) {
      newErrors.mobile = "Mobile number must be exactly 10 digits.";
    }

    // Required fields
    if (!editData.name.trim()) newErrors.name = "Name is required.";
    if (!editData.address.trim()) newErrors.address = "Address is required.";
    if (!editData.customerType) newErrors.customerType = "Customer Type is required.";
    if (!editData.paymentCycle) newErrors.paymentCycle = "Payment Cycle is required.";

    // Email: valid email format
    if (editData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveAddresses = async () => {
    const payload = {
      User: sessionStorage.getItem("username") || "admin",
      Vid: isEdit ? id : '', // For new, perhaps 0 or something
      Items: addresses.map((addr, index) => ({
        ItemId: index + 1, // Or 0 for new
        ShortName: addr.short,
        Address: addr.address,
        Area: addr.area,
        Item_Type: "Address", // Assuming
        Route: addr.route,
      })),
    };

    try {
      const response = await api.CustomerAddAPI(payload);
      console.log("Save Addresses Response:", response);
      alert("Addresses saved successfully!");
      setShowModal(false);
    } catch (error) {
      console.error("Error saving addresses:", error);
      alert("Failed to save addresses.");
    }
  };

  const handleSave = async () => {
    if (!validateForm()) {
      alert("Please correct the errors before saving.");
      return;
    }
    setLoading(true);
    const payload = {
      Sp_SqlAction: isEdit ? "UPDATE" : "INSERT",
      Vid: isEdit ? id : '',
      CustomerType: editData.customerType || "Regular",
      Mobile: editData.mobile || "",
      Phone: editData.altMobile || "",
      Vname: editData.name || "",
      Address: editData.address || "",
      Area: editData.area || "",
      Pincode: editData.pinCode || "",
      PayMode: editData.paymentCycle || "",
      Mail: editData.email || "",
      StateCode: editData.stateCode || "",
      Route: editData.route || "",
      active: editData.active === 'Active' ? 1 : 0,
      GST: editData.gstNo || "",
      shippingAddress: editData.address || "",
      VType: "Customer",
      PartnerRole: "Customer",
      AreaId: "",
      username: sessionStorage.getItem("username") || "admin",
      PaymentCycle1: editData.paymentCycle || "",
      PaymentCycle2: "",
      Notes: "",
      PaymentRemarks: "",
      IsCodAvail: isCodAvail,
    };

    try {
      const response = await api.FdCustomreSaveAPI(payload);
      console.log("✅ Save Response:", response);
      navigate("/CustomerExplr");
    } catch (error) {
      console.error("❌ Error saving customer:", error);
      alert("Failed to save customer. Please check console.");
    } finally {
      setLoading(false);
    }
  };

  const css = `
    * {
      box-sizing: border-box;
    }
    .customer-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 24px;
      font-family: 'Roboto', Arial, Helvetica, sans-serif;
      background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
      min-height: 100vh;
    }
    .customer-card {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
      padding: 32px;
      margin-bottom: 24px;
      border: 1px solid #e5e7eb;
      transition: box-shadow 0.3s ease;
    }
    .customer-card:hover {
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1);
    }
    .customer-title {
      color: #f97316;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 32px;
      text-align: center;
      position: relative;
    }
    .customer-title::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 4px;
      background: linear-gradient(90deg, #f97316, #ea580c);
      border-radius: 2px;
    }
    .form-row-4 {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      margin-bottom: 20px;
    }
    .form-row-3 {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      margin-bottom: 20px;
    }
    .form-row-5 {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 20px;
      margin-bottom: 20px;
    }
    .form-field {
      display: flex;
      flex-direction: column;
    }
    .form-field.full-width {
      grid-column: span 4;
    }
    .form-field label {
      background: #fff;
      color: #131212;
      font-size: 14px;
      margin-bottom: 8px;
      font-weight: 600;
      padding: 6px 12px;
      border-radius: 6px;
      display: inline-block;
    }
    .form-field input,
    .form-field select {
       padding: 8px 12px;          
  border: 1px solid #e5e7eb;  
      border-radius: 8px;
      font-size: 14px;
      background: #fff;
      width: 100%;
       font-weight: 400; 
      transition: border-color 0.3s ease, box-shadow 0.3s ease;
    }
    .form-field input:focus,
    .form-field select:focus {
      outline: none;
      border-color: #f97316;
      box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
    }
    .actions {
      display: flex;
      justify-content: center;
      gap: 16px;
      margin-top: 32px;
      margin-bottom: 16px;
    }
    .btn-secondary {
      background: linear-gradient(135deg, #6b7280, #4b5563);
      color: white;
      border: none;
      padding: 12px 32px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .btn-secondary:hover {
      background: linear-gradient(135deg, #4b5563, #374151);
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
    .btn-primary {
      background: linear-gradient(135deg, #f97316, #ea580c);
      color: white;
      border: none;
      padding: 12px 32px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(249, 115, 22, 0.3);
    }
    .btn-primary:hover {
      background: linear-gradient(135deg, #ea580c, #dc2626);
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(249, 115, 22, 0.4);
    }
    .link {
      color: #f97316;
      cursor: pointer;
      text-decoration: none;
      font-size: 14px;
      font-weight: 500;
    }
    .link:hover {
      color: #ea580c;
    }
    .modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }
    .modal-content {
      background: white;
      border-radius: 8px;
      width: 90%;
      max-width: 900px;
      max-height: 95vh;
      overflow-y: auto;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    }
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid #e5e7eb;
      background: #fef3c7;
      border-radius: 8px 8px 0 0;
    }
    .modal-header h3 {
      margin: 0;
      color: #374151;
      font-size: 18px;
    }
    .close {
      cursor: pointer;
      font-size: 28px;
      color: #374151;
      line-height: 1;
      font-weight: 300;
    }
    .close:hover {
      color: #000;
    }
    .modal-toolbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid #e5e7eb;
    }
    .modal-toolbar h4 {
      margin: 0;
      color: #374151;
      font-size: 16px;
    }
    .modal-actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      padding: 15px 20px;
      border-top: 1px solid #e5e7eb;
    }
    .address-table {
      width: 100%;
      border-collapse: collapse;
      margin: 0;
    }
    .address-table th,
    .address-table td {
      padding: 10px;
      border: 1px solid #e5e7eb;
      text-align: left;
    }
    .address-table th {
      background: #fef3c7;
      font-weight: 600;
      color: #374151;
      font-size: 14px;
    }
    .address-table tbody tr:hover {
      background: #fef9f5;
    }
    .address-table input,
    .address-table select {
      width: 100%;
      padding: 6px 8px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      font-size: 14px;
    }
    .btn-delete {
      background: #dc2626;
      color: white;
      border: none;
      padding: 6px 12px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      transition: background 0.2s;
    }
    .btn-delete:hover {
      background: #b91c1c;
    }

    .customer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
}

.customer-title {
  margin: 0;
  text-align: left;
}

.actions-inline {
  margin-top: 0;
  margin-bottom: 0;
}


    /* =========================
   MOBILE & TABLET FIXES
   ========================= */

/* Tablets */
@media (max-width: 1024px) {
  .form-row-5 {
    grid-template-columns: repeat(2, 1fr);
  }
  .form-row-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 768px) {
  .customer-container {
    padding: 12px;
  }

  .customer-card {
    padding: 16px;
  }

  .form-row-5,
  .form-row-4,
  .form-row-3 {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .form-field.full-width {
    grid-column: span 1;
  }

  .form-field label {
    font-size: 13px;
    padding: 4px 8px;
  }

  .form-field input,
  .form-field select {
    padding: 10px 12px;
    font-size: 14px;
  }

  .customer-title {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .actions {
    flex-direction: column;
    gap: 10px;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    padding: 12px;
  }

  .modal-content {
    width: 95%;
    max-width: none;
  }

  .address-table {
    font-size: 12px;
  }

  .address-table th,
  .address-table td {
    padding: 6px;
  }
}

/* Small phones */
@media (max-width: 480px) {
  .customer-title {
    font-size: 16px;
  }

  .form-field input,
  .form-field select {
    font-size: 13px;
  }
}


  `;

  if (isEdit && fetchLoading) {
    return (
      <div className="min-h-screen bg-gray-50" style={{ fontFamily: 'Roboto, Arial, Helvetica, sans-serif' }}>
        <Header onLogout={handleLogout} />
        <main className="p-6 md:ml-64">
          <div className="text-center">Loading customer data...</div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: 'Roboto, Arial, Helvetica, sans-serif', fontWeight: '600' }}>
      <style>{css}</style>
      <Header onLogout={handleLogout} />
      <main className="p-6 md:ml-64">
        <div className="customer-container">
          <div className="customer-card">
          <div className="mb-2 flex items-center justify-between rounded-2xl bg-orange-500 p-1 text-white shadow-xl">

  <div className="flex items-center gap-2">
     <button
             onClick={() => navigate("/CustomerExplr")}
              className="inline-flex items-center gap-1 px-3 py-1 text-gray-800 font-semibold
                 bg-gray-200 hover:bg-gray-300 rounded-full shadow transition
                 text-sm sm:text-base w-auto self-start"
            >
              ← Back
            </button>
  </div>

  {/* TITLE */}
  <h2 className="text-xl sm:text-2xl font-bold text-center flex-1">
    {isEdit ? "Edit Customer" : "New Customer"}
  </h2>

  {/* ACTIONS */}
  <div className="flex gap-3">
    <button
      onClick={handleSave}
      disabled={loading}
      className="rounded-lg bg-white px-3 py-2 text-orange-500 font-semibold
                 shadow-md transition duration-150 hover:bg-slate-50 disabled:opacity-60"
    >
      {loading
        ? isEdit
          ? "Updating..."
          : "Saving..."
        : isEdit
        ? "Update"
        : "Save"}
    </button>

    <button
      onClick={() => navigate("/CustomerExplr")}
      className="rounded-lg border border-white px-2 py-2
                 text-white font-semibold transition duration-150
                 hover:bg-white hover:text-orange-500"
    >
      Close
    </button>
  </div>

</div>



            <div className="form-row-4">
              <Field label="Customer Type *">
                <div className="relative" ref={customerTypeRef}>
                  <input
                    type="text"
                    value={customerTypeSearch}
                    onChange={(e) => {
                      setCustomerTypeSearch(e.target.value);
                      setActiveIndexCustomerType(-1);
                    }}
                    onClick={() => setShowCustomerTypeList(!showCustomerTypeList)}
                    onKeyDown={handleKeyDownCustomerType}
                    placeholder="Select Customer Type"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
                    disabled={dropdownLoading}
                  />
                  {showCustomerTypeList && (
                    <ul ref={listRefCustomerType} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                      {filteredCustomerTypes.length > 0 ? (
                        filteredCustomerTypes.map((type, index) => (
                          <li
                            key={type.Type}
                            onClick={() => {
                              setEditData({ ...editData, customerType: type.Type });
                              setCustomerTypeSearch(type.Type);
                              setShowCustomerTypeList(false);
                              setActiveIndexCustomerType(-1);
                            }}
                            onMouseEnter={() => setActiveIndexCustomerType(index)}
                            className={`px-4 py-2 cursor-pointer ${
                              index === activeIndexCustomerType
                                ? "bg-gray-100 font-semibold"
                                : "hover:bg-orange-100"
                            }`}
                          >
                            {type.Type}
                          </li>
                        ))
                      ) : (
                        <li className="px-4 py-2 text-gray-500">No customer types found</li>
                      )}
                    </ul>
                  )}
                </div>
                {errors.customerType && <p style={{color: 'red', fontSize: '12px'}}>{errors.customerType}</p>}
              </Field>

              <Field label="Mobile No *">
                <input type="text" name="mobile" value={editData.mobile} onChange={handleChange} />
                {errors.mobile && <p style={{color: 'red', fontSize: '12px'}}>{errors.mobile}</p>}
              </Field>

              <Field label="Alternate Mobile No">
                <input type="text" name="altMobile" value={editData.altMobile} onChange={handleChange} />
              </Field>

              <Field label="Name *">
                <input type="text" name="name" value={editData.name} onChange={handleChange} />
                {errors.name && <p style={{color: 'red', fontSize: '12px'}}>{errors.name}</p>}
              </Field>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <Field label="Address *" fullWidth>
                <input type="text" name="address" value={editData.address} onChange={handleChange} />
                {errors.address && <p style={{color: 'red', fontSize: '12px'}}>{errors.address}</p>}
              </Field>
            </div>

            <div className="form-row-5">
              <Field label="Area">
                <div className="relative" ref={areaRef}>
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setActiveIndexArea(-1);
                    }}
                    onClick={() => setShowAreaList(!showAreaList)}
                    onKeyDown={handleKeyDownArea}
                    placeholder="Select Area"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
                    disabled={areaLoading}
                  />
                  {showAreaList && (
                    <ul ref={listRefArea} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                      {filteredAreas.length > 0 ? (
                        filteredAreas.map((area, index) => (
                            <li
                              key={area.Area}
                             onClick={() => {
  const selected = areas.find(a => a.Area === area.Area);

  setEditData(prev => ({
    ...prev,
    area: area.Area,
    route: selected?.Division || ""   // ✅ AUTO ROUTE
  }));

  setSearchTerm(area.Area);
  setShowAreaList(false);
  setActiveIndexArea(-1);
}}
                              onMouseEnter={() => setActiveIndexArea(index)}
                              className={`px-4 py-2 cursor-pointer ${
                                index === activeIndexArea
                                  ? "bg-gray-100 font-semibold"
                                  : "hover:bg-orange-100"
                              }`}
                            >
                            {area.Area}
                          </li>
                        ))
                      ) : (
                        <li className="px-4 py-2 text-gray-500">No areas found</li>
                      )}
                    </ul>
                  )}
                </div>
              </Field>

              <Field label="Payment Cycle *">
                <div className="relative" ref={paymentCycleRef}>
                  <input
                    type="text"
                    value={paymentCycleSearch}
                    onChange={(e) => {
                      setPaymentCycleSearch(e.target.value);
                      setActiveIndexPaymentCycle(-1);
                    }}
                    onClick={() => setShowPaymentCycleList(!showPaymentCycleList)}
                    onKeyDown={handleKeyDownPaymentCycle}
                    placeholder="Select Payment Cycle"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
                    disabled={dropdownLoading}
                  />
                  {showPaymentCycleList && (
                    <ul ref={listRefPaymentCycle} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                      {filteredPaymentCycles.length > 0 ? (
                        filteredPaymentCycles.map((cycle, index) => (
                            <li
                              key={cycle.PaymentCycle}
                              onClick={() => {
                                const value = cycle.PaymentCycle;
                                setEditData({ ...editData, paymentCycle: value });
                                setPaymentCycleSearch(value);
                                setShowPaymentCycleList(false);
                                setActiveIndexPaymentCycle(-1);
                                if (value) {
                                  // Trigger secondary API
                                  const fetchDetails = async () => {
                                    try {
                                      setPaymentCycleDetailLoading(true);
                                      const response = await api.GetPaymentCycleAPI(value);
                                      console.log("Secondary API Response for PaymentCycle:", value, response);
                                      const data = response.GetPaymentCycleAPIjs || response.data || response.GetPaymentCycleAPI || response;
                                      setPaymentCycleDetails(data.Table || []);
                                      console.log("Payment Cycle Details:", data.Table || []);
                                    } catch (error) {
                                      console.error("❌ Error fetching payment cycle details:", error);
                                      setPaymentCycleDetails([]);
                                    } finally {
                                      setPaymentCycleDetailLoading(false);
                                    }
                                  };
                                  fetchDetails();
                                } else {
                                  setPaymentCycleDetails([]);
                                }
                              }}
                              onMouseEnter={() => setActiveIndexPaymentCycle(index)}
                              className={`px-4 py-2 cursor-pointer ${
                                index === activeIndexPaymentCycle
                                  ? "bg-gray-100 font-semibold"
                                  : "hover:bg-orange-100"
                              }`}
                            >
                            {cycle.PaymentCycle}
                          </li>
                        ))
                      ) : (
                        <li className="px-4 py-2 text-gray-500">No payment cycles found</li>
                      )}
                    </ul>
                  )}
                </div>
              </Field>

              <Field label="Payment Cycle Details">
                <div className="relative" ref={paymentCycleDetailRef}>
                  <input
                    type="text"
                    value={paymentCycleDetailSearch}
                    onChange={(e) => {
                      setPaymentCycleDetailSearch(e.target.value);
                      setActiveIndexPaymentCycleDetail(-1);
                    }}
                    onClick={() => setShowPaymentCycleDetailList(!showPaymentCycleDetailList)}
                    onKeyDown={handleKeyDownPaymentCycleDetail}
                    placeholder="Select Details"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
                    disabled={paymentCycleDetailLoading || !editData.paymentCycle}
                  />
                  {showPaymentCycleDetailList && (
                    <ul ref={listRefPaymentCycleDetail} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                      {filteredPaymentCycleDetails.length > 0 ? (
                        filteredPaymentCycleDetails.map((detail, index) => (
                            <li
                              key={detail.PaymentCycle}
                              onClick={() => {
                                setSelectedPaymentCycleDetail(detail);
                                setPaymentCycleDetailSearch(detail.PaymentCycle);
                                setShowPaymentCycleDetailList(false);
                                setActiveIndexPaymentCycleDetail(-1);
                              }}
                              onMouseEnter={() => setActiveIndexPaymentCycleDetail(index)}
                              className={`px-4 py-2 cursor-pointer ${
                                index === activeIndexPaymentCycleDetail
                                  ? "bg-gray-100 font-semibold"
                                  : "hover:bg-orange-100"
                              }`}
                            >
                            {detail.PaymentCycle}
                          </li>
                        ))
                      ) : (
                        <li className="px-4 py-2 text-gray-500">No details found</li>
                      )}
                    </ul>
                  )}
                </div>
              </Field>

              <Field label="Pin Code">
                <input type="text" name="pinCode" value={editData.pinCode} onChange={handleChange} />
              </Field>

              <Field label="Email">
                <input type="email" name="email" value={editData.email} onChange={handleChange} />
                {errors.email && <p style={{color: 'red', fontSize: '12px'}}>{errors.email}</p>}
              </Field>
            </div>

            <div className="form-row-3">
              <Field label="Route">
                <input type="text" name="route" value={editData.route} onChange={handleChange} readOnly
                 />
              </Field>

              <Field label="Active">
                <div className="relative" ref={activeRef}>
                  <input
                    type="text"
                    value={activeSearch}
                    onChange={(e) => {
                      setActiveSearch(e.target.value);
                      setActiveIndexActive(-1);
                    }}
                    onClick={() => setShowActiveList(!showActiveList)}
                    onKeyDown={handleKeyDownActive}
                    placeholder="Select Status"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
                    disabled={dropdownLoading}
                  />
                  {showActiveList && (
                    <ul ref={listRefActive} className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded-md shadow-lg max-h-60">
                      {filteredActives.length > 0 ? (
                        filteredActives.map((status, index) => (
                            <li
                              key={status.Active}
                              onClick={() => {
                                setEditData({ ...editData, active: status.Active });
                                setActiveSearch(status.Active);
                                setShowActiveList(false);
                                setActiveIndexActive(-1);
                              }}
                              onMouseEnter={() => setActiveIndexActive(index)}
                              className={`px-4 py-2 cursor-pointer ${
                                index === activeIndexActive
                                  ? "bg-gray-100 font-semibold"
                                  : "hover:bg-orange-100"
                              }`}
                            >
                            {status.Active}
                          </li>
                        ))
                      ) : (
                        <li className="px-4 py-2 text-gray-500">No statuses found</li>
                      )}
                    </ul>
                  )}
                </div>
              </Field>

              <Field label="State Code">
                <input type="text" name="stateCode" value={editData.stateCode} onChange={handleChange} />
              </Field>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <Field label="GST No" fullWidth>
                <input type="text" name="gstNo" value={editData.gstNo} onChange={handleChange} />
              </Field>
            </div>

            {/* <div className="actions">
              <button className="btn-secondary" onClick={() => navigate("/CustomerExplr")}>Cancel</button>
              <button className="btn-primary" onClick={handleSave} disabled={loading}>{loading ? (isEdit ? 'Updating...' : 'Saving...') : (isEdit ? 'Update' : 'Save')}</button>
            </div> */}

 <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",   // space between both items
    marginTop: "16px"
  }}
>

  <span
    className="link"
    onClick={() => setShowModal(true)}
    style={{ cursor: "pointer" }}
  >
    🏠+ Additional Addresses
  </span>

  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <input
      type="checkbox"
      id="onlineCod"
      checked={isCodAvail === 1}
      onChange={(e) => setIsCodAvail(e.target.checked ? 1 : 0)}
      style={{ width: "16px", height: "16px" }}
    />
    <label
      htmlFor="onlineCod"
      style={{ fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
    >
      Online COD
    </label>
  </div>

</div>

            </div>
 

          {showModal && (
            <div className="modal" onClick={() => setShowModal(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Additional Address Management</h3>
                  <span className="close" onClick={() => setShowModal(false)}>×</span>
                </div>

                <div className="modal-toolbar">
                  <h4>Address List</h4>
                  <button className="btn-primary" onClick={addRow}>+ Add</button>
                </div>

                <table className="address-table">
                  <thead>
                    <tr>
                      <th>Short Name</th>
                      <th>Address</th>
                      <th>Area</th>
                      <th>Route</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addresses.map((a, i) => (
                      <tr key={i}>
                        <td><input type="text" value={a.short} onChange={(e) => {
                          const newAddresses = [...addresses];
                          newAddresses[i].short = e.target.value;
                          setAddresses(newAddresses);
                        }} /></td>
                        <td><input type="text" value={a.address} onChange={(e) => {
                          const newAddresses = [...addresses];
                          newAddresses[i].address = e.target.value;
                          setAddresses(newAddresses);
                        }} /></td>
                        <td>
                          <select
  value={a.area}
  onChange={(e) => {
    const selectedArea = e.target.value;

    // find selected area object
    const selected = areas.find(ar => ar.Area === selectedArea);

    const newAddresses = [...addresses];
    newAddresses[i] = {
      ...newAddresses[i],
      area: selectedArea,
      route: selected?.Division || ""   // ✅ AUTO BIND ROUTE
    };

    setAddresses(newAddresses);
  }}
  disabled={dropdownLoading}
>
  <option value="">Select Area</option>
  {areas.map((area, index) => (
    <option key={index} value={area.Area}>
      {area.Area}
    </option>
  ))}
</select>

                        </td>
                        <td><input type="text" value={a.route} readOnly onChange={(e) => {
                          const newAddresses = [...addresses];
                          newAddresses[i].route = e.target.value;
                          setAddresses(newAddresses);
                        }} /></td>
                        <td><button className="btn-delete" onClick={() => deleteRow(i)}>Delete</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="modal-actions">
                  <button className="btn-primary" onClick={handleSaveAddresses}>
                    {isEdit ? "Update Addresses" : "Save Addresses"}
                  </button>
                  <button className="btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

function Field({ label, children, fullWidth }) {
  return (
    <div className={`form-field ${fullWidth ? "full-width" : ""}`}>
      <label>{label}</label>
      {children}
    </div>
  );
}